import React from "react";
import styled from "styled-components";


export default styled.span`
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 1 auto;
    text-align: center;
    height: 61px;
    padding: 15px;
    background: rgb(239 240 243);
    border-radius: 10px;
    color: rgb(136 136 136);
    font-weight: 700;
    white-space: nowrap;

    box-sizing: border-box;
    @media(max-width: 1553px) {
        display: flex;
    }

    @media(max-width: 1024px) {
        display: none;
    }
`;
